var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function MobileIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 20V18H8V20H11C11 19.4472 11.4439 19 12 19C12.5523 19 13 19.4491 13 19.999L16 20ZM16 8H8V16H16V8ZM16 6V4H8V6H16ZM7.00247 2H16.9975C17.5512 2 18 2.44577 18 2.99865V21.0014C18 21.5529 17.5515 22 16.9975 22H7.00247C6.44882 22 6 21.5542 6 21.0014V2.99865C6 2.44711 6.44851 2 7.00247 2Z", fill: "" })));
}
export var MobileIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: MobileIconInner }, props))); };
//# sourceMappingURL=MobileIcon.js.map